import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.css']
})
export class ContactsComponent implements OnInit {
  myForm: FormGroup;

  constructor(private meta: Meta, private titleService: Title) {}

  ngOnInit() {
    window.scrollTo(0, 0);
    this.titleService.setTitle('Contact Us');
    this.meta.updateTag({
      name: 'description',
      content: 'We’re here to listen, help, and grow with you. Reach out anytime, we’re just a message away!'
    });

    const contactSection = document.getElementById('contacts');
    if (contactSection) {
      contactSection.style.backgroundColor = 'red';
    }

    // ✅ Initialize form group
    this.myForm = new FormGroup({
      name: new FormControl(''),
      email: new FormControl(''),
      phone: new FormControl(''),
      message: new FormControl(''),
      agree: new FormControl(false)
    });
  }

  onSubmit() {
    if (this.myForm.valid) {
      console.log('Form submitted:', this.myForm.value);
      // You can send this.myForm.value to your backend here
    } else {
      console.log('Form is invalid');
    }
  }
}
